const select = document.getElementsByClassName("section-experts_select")[0];
const labelsList = document.getElementsByClassName("section-experts_buttons_label");

if(labelsList) {  
  for (var i = 0; i < labelsList.length; i++) {
    labelsList[i].addEventListener('click', function (event) {
      const labelFor = this.getAttribute("for");
      select.value=labelFor;
    });
  }
}

if(select) {
  select.addEventListener('change', function (event) {
    const value = select.value;
    const input=document.getElementById(value);
    input.checked = true
  });
}